import {Box} from '@mui/material';
import {UserRoleColors} from '../../styles/colors';
import {getAccentColor} from '../../styles/utils';
import StyledChip from '../StyledComponents/StyledChip';

type RoleChipsProps = {
  roles: string[];
  size?: 'small' | 'medium';
};

function RoleChips({roles, size = 'small'}: RoleChipsProps) {
  if (roles.length === 0) {
    return <StyledChip size={size} label="No roles" color={UserRoleColors.default} />;
  }
  return (
    <Box display="flex" flexWrap="wrap">
      {roles.map((role) => (
        <StyledChip key={role} size={size} label={role} color={getAccentColor(role)} />
      ))}
    </Box>
  );
}

export default RoleChips;
